import React from "react";

import styles from "./style.module.scss";
import MeetUsWrapper from "Components/MeetUsWrapper";
import IconColck from "../../../Utils/Assets/Icons/IconColck.png";
import CoinsVideo from "../../../Utils/Assets/Images/coins-rotating.webm";

import { useEffect, useState } from "react";

const LimitedTimeOffer = () => {
    const [timeLeft, setTimeLeft] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
    });

    useEffect(() => {
        const targetDate = new Date();
        targetDate.setDate(targetDate.getDate() + 1);

        const interval = setInterval(() => {
            const now = new Date();
            const difference = targetDate - now;

            const days = Math.floor(difference / (1000 * 60 * 60 * 24));
            const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
            const minutes = Math.floor((difference / (1000 * 60)) % 60);
            const seconds = Math.floor((difference / 1000) % 60);

            setTimeLeft({ days, hours, minutes, seconds });

            if (difference <= 0) clearInterval(interval);
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    return (
        <div className={styles.container}>
            <MeetUsWrapper>
                <div className={styles.cardBorderWrapper}>
                    <div className={styles.cardBorder}>
                        <div className={styles.cardFlex}>
                            {/* Text */}
                            <div
                                className={styles.flexCol}
                                data-aos="fade-right"
                                data-aos-duration="800"
                                data-aos-once="false"
                            >
                                <div className={styles.flex}>
                                    <img src={IconColck} alt="IconColck" />
                                    <p className="">
                                        Limited-Time Bonus: Earn More MVR by Joining Now!
                                    </p>
                                </div>
                                <div className={styles.subtext}>
                                    <p className="">
                                        Be Part of the Future –{" "}
                                        <br />
                                        Join MeetUsVR Today!
                                    </p>
                                    <div className={styles.buttonRight}>
                                        <button>Start Earning MVR Today — Download Now!</button>
                                    </div>
                                </div>
                            </div>

                            <div className="">
                                <video
                                    src={CoinsVideo}
                                    autoPlay
                                    loop
                                    muted
                                    playsInline
                                    className={styles.coinsVideo}
                                    data-aos="fade-up"
                                    data-aos-duration="800"
                                ></video>
                            </div>
                        </div>

                        <div className={styles.cards}>
                            <div className={styles.card}>
                                <h3>
                                    {timeLeft.days.toString().padStart(2, "0")}
                                </h3>
                                <p>Days</p>
                            </div>
                            <span>:</span>
                            <div className={styles.card}>
                                <h3>
                                    {timeLeft.hours.toString().padStart(2, "0")}
                                </h3>
                                <p>Hours</p>
                            </div>
                            <span>:</span>
                            <div className={styles.card}>
                                <h3>
                                    {timeLeft.minutes
                                        .toString()
                                        .padStart(2, "0")}
                                </h3>
                                <p>Minute</p>
                            </div>
                            <span>:</span>
                            <div className={styles.card}>
                                <h3>
                                    {timeLeft.seconds
                                        .toString()
                                        .padStart(2, "0")}
                                </h3>
                                <p>Second</p>
                            </div>
                        </div>
                    </div>
                </div>
            </MeetUsWrapper>
        </div>
    );
};

export default LimitedTimeOffer;
